<template>
  <div>
    <wc-section-title title='Software'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'software-base',
  computed: {
    menu () {
      return [
        {
          title: 'Software Dashboard',
          icon: this.$store.state.icons.modules.software.icon,
          route: { name: 'SoftwareDashboard' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Software Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
